import React from 'react';
import * as Styles from '../NewHomeLayoutHandler/NewHomeLayoutHandler.styles';
import { Button } from 'gatorcomponents';
import HomeBannerCreateWithAi from '@/media/home/home_banner_create_with_ai_pt_br.png';

const Banner = ({
  locale,
  onCreateSiteWithAi,
}) => (
  <Styles.InnerCard data-testid="home-create-site-with-ai-banner">
    <Styles.InnerCardColumn>
      <Styles.Image src={HomeBannerCreateWithAi} />
    </Styles.InnerCardColumn>

    <Styles.InnerCardColumn>
      <Styles.InnerCardColumnTitle>{locale.listTitle}</Styles.InnerCardColumnTitle>

      <Styles.InnerCardColumnList>
        {locale?.list?.map(item => (
          <Styles.InnerCardColumnListItem key={item.text}>
            {item.icon}
            {item.text}
          </Styles.InnerCardColumnListItem>
        ))}
      </Styles.InnerCardColumnList>

      <Styles.InnerCardButtonWrapper>
        <Button
          size="xlarge"
          label={locale.cta}
          onClick={onCreateSiteWithAi}
        />
      </Styles.InnerCardButtonWrapper>
    </Styles.InnerCardColumn>
  </Styles.InnerCard>
);

export default Banner;
